<template>
  <div class="main-box">
    <h1>Person erstellen</h1>
    <div class="my-2">
      <b-button to="/person">Zurück</b-button>
    </div>

    <b-alert v-model="hasUnknownError" variant="danger">
      {{ unknownErrorMessage }}
    </b-alert>

    <validation-observer ref="observer" v-slot="{ passes }">
      <b-form @submit.prevent="passes(onSubmit)">
        <person-add :form="form" />
        <b-button type="submit" variant="primary" disabled v-if="isSubmitting">
          <b-spinner small></b-spinner>
          Person erfassen
        </b-button>
        <b-button type="submit" variant="primary" v-else>Person erfassen</b-button>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
  import { ValidationObserver } from 'vee-validate'
  import { errorHandler } from '@/helpers/formHelper.js'
  import PersonAdd from '@/components/person/PersonAdd.vue'

  const getInitialData = () => ({
    form: {
      anrede: 'Herr',
      vorname: '',
      name: '',
      firma: '',
      zusatz: '',
      uid: '',
      oeffentlicheHand: false,
      strasse: '',
      hausNr: '',
      postfach: '',
      plz: '',
      ort: '',
      telefon: '',
      email: '',
      land: 16
    }
  })

  export default {
    components: {
      ValidationObserver,
      PersonAdd
    },
    data: () => ({
      isSubmitting: false,
      hasUnknownError: false,
      unknownErrorMessage: '',
      hasError: false,
      errorMessage: '',
      ...getInitialData()
    }),
    methods: {
      scrollTo () {
        this.$scrollTo('.logo')
      },
      onSubmit () {
        this.isSubmitting = true
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('person/SAVE_PERSON', {
          formData: this.form
        }).then(res => {
          const { errors } = res

          if (errors) {
            this.isSubmitting = false
            this.scrollTo()
            return errorHandler(this, errors)
          }

          this.isSubmitting = false
          this.$router.push({ name: 'personen' }).catch((e) => {})
        }).catch(err => {
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          this.isSubmitting = false
          this.scrollTo()
          console.error(err)
        })
      },
      reset () {
        Object.assign(this.$data, getInitialData())
        requestAnimationFrame(() => {
          this.$refs.observer.reset()
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .optional{
    text-decoration: underline;
  }
</style>
